import { render, staticRenderFns } from "./MemberUpgrades.vue?vue&type=template&id=ea55b418&"
import script from "./MemberUpgrades.vue?vue&type=script&lang=js&"
export * from "./MemberUpgrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports